module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secondaryNavigation"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/supplier/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.t('Dashboard')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/admin/users'
    }
  }, [_vm._v(_vm._s(_vm.t('Users')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/admin/activities'
    }
  }, [_vm._v(_vm._s(_vm.t('Activities')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": ("/" + (this.$store.state.language) + "/admin/bookings")
    }
  }, [_vm._v(_vm._s(_vm.t('Bookings')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/admin/payments'
    }
  }, [_vm._v(_vm._s(_vm.t('Payments')))])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74ee8937", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74ee8937"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Navigation/SecondaryNavigation.vue
// module id = 791
// module chunks = 3